import { createContext, useContext } from 'react';

// Simplified context: Only shares active state and clear action
export interface FilterButtonContextValue {
  isFilterActive: boolean;
  onClear: () => void;
  closePopover: () => void;
}

const FilterButtonContext = createContext<FilterButtonContextValue | undefined>(undefined);

export const useFilterButtonContext = () => {
  const context = useContext(FilterButtonContext);
  if (!context) {
    throw new Error(
      'FilterButton compound components cannot be rendered outside the FilterButton component'
    );
  }
  return context;
};

export const FilterButtonProvider = FilterButtonContext.Provider;
